export default {
  ADD_RUNNING: 'campaign-targets/ADD_RUNNING',
  ADD_PAUSED: 'campaign-targets/ADD_PAUSED',
  CLEAR_SELECTION: 'campaign-targets/CLEAR_SELECTION',
}
